module.exports = __webpack_public_path__ + "assets/img/AIF-Social-Static-Ad-w540.344cf0e5.png";